import { v4 as uuidv4 } from "uuid";

export function newGuid(): ReturnType<typeof crypto.randomUUID> {
	return uuidv4();
}
